export default {
    CANNOT_ACCESS_LOOTBAG: 'No puedes acceder a este botín en este momento.',
    REQUIRES_ACHIEVEMENT: 'Este artículo requiere de un logro secreto para equiparlo.',
    REQUIRES_QUEST: 'Debes completar {{quest}} para equipar este artículo.',
    SKILL_LEVEL_REQUIREMENT_EQUIP:
        'Tu {{skill}} debe tener al menos el nivel {{level}} para equipar esto.',
    TOTAL_LEVEL_REQUIREMENT:
        'Tu nivel total debe ser al menos {{level}} para equipar este artículo.'
} as const;
